import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPulse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.00157 2.5C9.30492 2.50064 9.57801 2.68394 9.69351 2.96444L15.9953 18.2688L18.5552 11.9677C18.67 11.685 18.9448 11.5 19.25 11.5H23.25C23.6642 11.5 24 11.8358 24 12.25C24 12.6642 23.6642 13 23.25 13H19.7548L16.6949 20.5323C16.5802 20.8145 16.3063 20.9993 16.0018 21C15.6972 21.0007 15.4225 20.8172 15.3065 20.5356L8.9959 5.20984L5.94231 12.5385C5.82586 12.8179 5.55278 13 5.25 13H0.75C0.335786 13 0 12.6642 0 12.25C0 11.8358 0.335786 11.5 0.75 11.5H4.75L8.30769 2.96154C8.42436 2.68153 8.69822 2.49937 9.00157 2.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgPulse;
